import { render, staticRenderFns } from "./CanteenPayment.vue?vue&type=template&id=68d864a1&lang=pug&"
import script from "./CanteenPayment.vue?vue&type=script&lang=js&"
export * from "./CanteenPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports